export const settingAccommodation = {
    p1: `المعلومات الأساسية`,
    p2: `أدخِل الاسم والشعار اللذين سيراهما المستخدمون عند بدء تسجيل الوصول. إذا لم يكن لديك شعار، فسيُستخدم شعار WACheckin الافتراضي.`,
    p3: `سياسات وحدة الإقامة`,
    p4: `خصّص سياسات وحدة إقامتك. ستكون هذه هي الشروط التي يوافق عليها النزلاء عند تسجيل الوصول.`,
    p5: `الإسبانية`,
    p6: `الإنجليزية`,
    p7: `رسالة الترحيب`,
    p8: `خصّص رسالة الترحيب التي سيراها نزلاؤك بعد إتمام تسجيل الوصول.`,
    p9: `مفاتيح الغرف`,
    p10: `سجّل الغرف المزوّدة بأقفال ذكية وأدِرها. أعِدّ رموز الدخول التي ستُمنح للنزلاء بعد تسجيل الوصول لتسهيل دخولهم.`,
    p11: `الجهات المختصة`,
    p12: `أعِدّ الاتصال بالجهات المحلية للإرسال التلقائي لبلاغات المسافرين. أدخِل اسم المستخدم وكلمة المرور الخاصّين بمنصّة كل جهة مختصة.`,
    p13: `Guardia Civil`,
    p14: `Policía Nacional`,
    p15: `Ertzaintza`,
    p16: `Mossos`,
    p17: `بيانات الدخول`,
    p18: `الجهة مطلوبة`,
    p19: `اسم المستخدم مطلوب`,
    p20: `كلمة المرور مطلوبة`,
    p21: `خطأ أثناء التحقق من البيانات`,
    p22: `الجهة مطلوبة`,
    p23: `اسم المستخدم مطلوب`,
    p24: `كلمة المرور مطلوبة`,
    p25: `تم تحديث البيانات بنجاح`,
    p26: `خطأ في إدخال بيانات شرطة الهجرة`,
    p27: `نزّل رمز QR الخاص بوحدة إقامتك لتسجيل وصول سريع، واحصل على الرابط لإرساله مباشرةً إلى النزلاء.`,
    p28: `تعديل رمز أمان وحدة الإقامة`,
    p29: `نتحقق من هوية النزلاء بمقارنة صورة بطاقة هويتهم أو جواز سفرهم بصورة ذاتية تُلتقط في الوقت الفعلي.`,
    p30: `بتفعيل هذا الخيار، سيُطلب من النزلاء التحقق من هويتهم أثناء تسجيل الوصول. وإذا لم يكتمل التحقق بنجاح، فلن يتمكّنوا من متابعة تسجيل الوصول.`,
    p31: `خطأ في تفعيل التحقق من الهوية`,
    p32: `إعدادات الدفع`,
    p33: `حصّل المدفوعات من النزلاء أثناء تسجيل الوصول، بما يتيح لهم دفع قيمة الخدمات الإضافية والرسوم المطبّقة.`,
    p34: `رمز أمان وحدة الإقامة`,
    p35: `وحدة الإقامة`,
    p36: `فعّل هذا الخيار لإرسال رسالة WhatsApp تلقائيًا يوم تسجيل المغادرة، تطلب من النزلاء تقييم تجربتهم في وحدة الإقامة من 1 إلى 5.`,
    p37: `أدخِل عنوان URL لموقع التقييمات الذي تريد إعداده ليترك نزلاؤك آراءهم فيه، سواء كان Google أو أي موقع تقييمات آخر تستخدمه. يساعد ذلك على تحسين ظهور وحدة الإقامة وسمعتها.`,
    p38: `أدخِل عنوان URL لموقع التقييمات (مثل Google أو TripAdvisor)`,
    p39: `أدِر وحدة إقامتك`,
    p40: `المعلومات الأساسية`,
    p41: `سياسات وحدة الإقامة`,
    p42: `رسالة الترحيب`,
    p43: `رمز QR لوحدة الإقامة`,
    p44: `مدفوعات النزلاء`,
    p45: `ارفع شعار وحدة الإقامة`,
    p46: `يمكنك رفع صورة أو سحبها إلى المربع`,
    p47: `التصميم`,
    p48: `السياسات`,
    p49: `الترحيب`,
    p50: `المنطقة`,
    p51: `الإسبانية`,
    p52: `الإنجليزية`,
    p53: `العربية`,
    p54:``,
    p55:``,
    p56:``,
    p57:``,
    p58:``,
    p59:``,
    p60:``,
    p61:``,
    p62:``,
    p63:``,
    p64:``,
    p65:``,
    p66:``,
    p67:``,
    p68:``,
    p69:``,
    p70:``,
};
